module.exports = __webpack_public_path__ + "img/logo21.c9c4a1d2.jpg";